// extracted by mini-css-extract-plugin
module.exports = {"root":"GetTicketsButton_root__EQHfJ","bordered":"GetTicketsButton_bordered__HElzv","icon":"GetTicketsButton_icon__rICQM"};